import React, { useEffect, useState } from "react";
import Header from "units/dashboard/components/Header";
import UserSidebar from "units/user/components/UserSidebar";
import AdminSidebar from "units/admin/components/AdminSidebar";
import Footer from "units/dashboard/components/Footer";
import feather from "feather-icons";
import "assets/css/icons.css";
import { SidebarProvider } from "units/dashboard/context/SidebarProvider";
import { useDispatch, useSelector } from "react-redux";
import { getUserType } from "../services/getUserProfile";
import { setUser } from "../store/userSlice";
import UserDashboard from "units/user/userDashboard/UserDashboard";
import AdminDashboard from "units/admin/AdminDashboard";
import ClientSidebar from "units/client/component/ClientSidebar";
import ClientDashboard from "units/client/component/ClientDashboard";
import ClientHeader from "units/client/component/ClientHeader";
import api from "api";
import CreatingKnowledgeBase from "units/user/CreatingKnowledgeBase";
import { getknowlageBaseInfo } from "units/user/services/knowlageBaseInfo";
import FloatingStepper from "units/components/FloatingStepper/FloatingStepper";
import { useNavigate } from "react-router-dom";
import Loading from "../components/Loading"
const DashboardLayout = () => {
  const [planName, setPlanName] = useState("")
  const [userType, setUserType] = useState(null);
  const accessToken = useSelector((state) => state.auth.accessToken);
  const dispatch = useDispatch()
  const navigate = useNavigate();
  // useEffect(() => {
  //   console.log("Fetching user...");
  //   if (!accessToken) {
  //       console.log("Access token not found");
  //       return;
  //   }

  //     const fetchUser = async () => {
  //       try {
  //         const res = await getUserType(accessToken);

  //         // const res = await api.user.getMe();
  //         console.log(res)
  //         if (res?.ok && res?.data) {
  //           dispatch(setUser(res.data)); 
  //           console.log(res.data, "user data");
  //           setUserType(res?.data?.userType)
  //         }
  //       } catch (error) {
  //         console.error("خطا در دریافت اطلاعات کاربر:", error);
  //       }
  //     };

  //     fetchUser();
  //   }, [accessToken, dispatch]);
  //   useEffect(() => {
  //     const botInfo = async () => {
  //       try {

  //         const res = await getknowlageBaseInfo(accessToken);
  //         if (res?.ok) {
  //           setPlanName(res?.data?.plan?.name);
  //           dispatch(setUser({
  //             ...userDataFromApi,   // داده‌های کاربر
  //             planName: name        // پلن جدید
  //           }));
  //         }
  //       } catch (error) {
  //         console.error("خطا در دریافت اطلاعات بات:", error);
  //       } 
  //     }
  //     botInfo();

  //   }, [accessToken,dispatch]);

  //   useEffect(() => {
  //       feather.replace();
  //   }, []);
  //   if (userType === null) {
  //     return <div>در حال بارگذاری...</div>;
  //   }

  //   const fetchUser = async () => {
  //     try {
  //       const res = await getUserType(accessToken);
  //       // const res = await api.user.getMe();
  //       if (res?.ok && res?.data) {
  //         dispatch(setUser(res.data));
  //         console.log(res.data, "user data");
  //         setUserType(res?.data?.userType);
  //       }
  //     } catch (error) {
  //       console.error("خطا در دریافت اطلاعات کاربر:", error);
  //     }
  //   };

  //   fetchUser();
  // }, [accessToken, dispatch]);

  useEffect(() => {
    if (!accessToken) return;

    const fetchUser = async () => {
      try {
        const res = await getUserType(accessToken);
        if (res?.ok && res?.data) {
          const userDataFromApi = res.data; // ⬅️ اول کاربر رو می‌گیری

          // حالا بات رو هم بگیر تا planName رو اضافه کنیم
          const botRes = await getknowlageBaseInfo(accessToken);
          const planName = botRes?.data?.plan?.name || "";
          const orgName = botRes?.data?.orgName || "";
          const name = botRes?.data?.name || "";

          // یک آبجکت کامل از کاربر بساز و planName رو هم اضافه کن
          const finalUser = {
            ...userDataFromApi,
            planName: planName,
            orgName: orgName,
            name: name,
          };
          // console.log("Final User Object:", finalUser);
          // ذخیره در ریداکس و localStorage
          dispatch(setUser(finalUser));

          setPlanName(planName);
          setUserType(userDataFromApi.userType);
          if (res.data.userType == 2) {
            navigate("/admin/dashboard")
          } else {
            navigate("/user/dashboard")
          }
        }
      } catch (error) {
        console.error("خطا در دریافت اطلاعات:", error);
      }
    };

    fetchUser();
  }, [accessToken, dispatch]);
  useEffect(() => {
    feather.replace();
  }, []);
  if (userType === null) {
    return <Loading />;
  }
  return (
    <>
      <nav
        className="border-b border-slate-100 dark:bg-zinc-800 print:hidden flex items-center fixed top-0 right-0 left-0
                     bg-white  dark:border-zinc-700 z-30 "
        style={{ zIndex: 100000 }}
      >
        {userType == 1 || userType == 2 ? <Header /> : <ClientHeader />}
      </nav>

      <div
        className="vertical-menu
                     rtl:right-0 fixed ltr:left-0 bottom-0 top-20 h-screen border-r bg-slate-50
                      border-gray-50 print:hidden dark:bg-zinc-800 dark:border-neutral-700 "
      >
        {userType == 1 ? (
          <UserSidebar />
        ) : userType == 0 ? (
          <ClientSidebar />
        ) : (
          <AdminSidebar />
        )}
      </div>

      <div className="flex flex-col min-h-screen ">
        <div className=" flex-grow">
          {userType == 1 && planName !== "رایگان" ? (
            <UserDashboard />
          ) : userType == 1 && planName == "رایگان" ? (
            <CreatingKnowledgeBase />
          ) : userType == 0 ? (
            <ClientDashboard />
          ) : (
            <AdminDashboard />
          )}
        </div>
      </div>
    </>
  );
};

export default DashboardLayout;
